import { FIXED_HOUSE_FORM_ITEM_KEYS } from './houseAddressMerge';

export const isChecklistStorageReady = checklist =>
  Boolean(
    checklist?.hasFetchedChecklistItemsFromStorage
    && !checklist?.isFetchingChecklistFromStorage,
  );

export const isFixedHouseItemsReady = items =>
  Boolean(items)
  && FIXED_HOUSE_FORM_ITEM_KEYS.every(
    key => items[key] && items[key].value !== undefined,
  );

export const isExternalAreaChecklistReady = checklist =>
  isChecklistStorageReady(checklist)
  && isFixedHouseItemsReady(checklist?.fixed?.house?.items);
